<template>
  <div id="wrap">
    <!-- logo -->
    <div class="logo"></div>
    <!-- title -->
    <div class="title">同城帮智能回收机</div>
    <div
      class="text"
    >智能回收机打通自动化技术壁垒，用户仅需放入手机，即可自动完成内部功能、外观评估、价格评估与自动回收，无需人工处理，为用户真正带来一键智能自动手机回收体验，三分钟即可收到回收款。</div>
    <!-- 展示栏 -->
    <div class="displayBar1">
      <div class="img"></div>
      <div class="content">
        <div class="title">智能换新</div>
        <div
          class="text"
        >同城帮独家研制智能换新机，用户可以自助进行以旧换新操作。完成旧机估价后，现场进行新机预定。也可以扫描机器上二维码，后续在合适时间自助完成旧机估价和新机购买。</div>
      </div>
    </div>
    <!-- 图片区域 -->
    <div class="img">
      <img src="../../assets/imgs/product/jg.png" alt />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#wrap {
  //   background-color: skyblue;
  .logo {
    width: 70px;
    height: 70px;
    background-image: url("../../assets/imgs/product/logoicon.png");
    background-size: cover;
    background-repeat: no-repeat;
    margin-bottom: 20px;
  }
  .title {
    color: #000000;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  .text {
    line-height: 28px;
    font-size: 16px;
    margin-bottom: 60px;
  }
  //   展示区
  .displayBar1 {
    width: 1034px;
    height: 321px;

    display: flex;
    margin-bottom: 70px;
    box-shadow: 0px 0px 20px #eee;
    .img {
      width: 327px;
      height: 321px;
      background-image: url("https://p2.ssl.qhimg.com/t01974f0b568167b13c.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    .content {
      width: 707px;
      height: 321px;
      padding: 77px 64px 110px 51px;
      .title {
        font-size: 20px;
        color: #03050e;
        font-weight: 600;
        margin-bottom: 38px;
      }
      .text {
        color: #666666;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  //   图片
  .img {
    margin-bottom: 70px;
    width: 1032px;
    height: 595px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
